import { Box, CssBaseline, useTheme } from "@mui/material";
import Sidebar from "../Sidebar";
import { Header } from "../Header";
import { Outlet } from "react-router-dom";
import { Footer } from "../Footer";

export const MainLayout = () => {
  // const theme = createAppTheme(); // Use your custom theme here
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        backgroundColor: theme.palette.primary.main,
        height: "100vh",
        width: "100vw",
      }}
    >
      <CssBaseline />
      <Sidebar />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          minWidth: 0,
        }}
      >
        <Header theme={theme} />
        <Box sx={{ flexGrow: 1, overflow: "auto", minWidth: 0 }}>
          <Outlet /> {/* This is where the nested routes will be rendered */}
        </Box>
        <Footer />
      </Box>
    </Box>
  );
};
